var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-progress-bar"},[_vm._v("RUSI Proliferation Financing Risk Exercise: "+_vm._s(_vm.step)+" / "+_vm._s(this.$store.state.totalSteps))])}
var staticRenderFns = []

export { render, staticRenderFns }